import startCase from 'lodash/startCase'
import get from 'lodash/get'
import * as api from '../api/cart'
import { formatDiamondShape, formatMetalType } from '../utils/format-labels'

export const addDiamondsToCart = (diamonds) => {
  return {
    type: 'ADD_DIAMONDS_TO_CART',
    value: diamonds
  }
}

export const removeDiamondFromCart = (id) => {
  return {
    type: 'REMOVE_DIAMOND_FROM_CART',
    value: id
  }
}

export const addCurrentJewelryToCart = () => {
  return (dispatch, getState) => {
    let data = getState().jewelrySearch.result
    let filters = getState().jewelrySearch.filters
    // replace the value for prong.has_cathedral_shoulder in data with the value for cathedral_shoulders
    // so that it could be rendered correctly in the jewelry detail component
    if (data.prong) {
      data.prong.has_cathedral_shoulder = filters.cathedral_shoulders
    }
    // if additional_price is 0, then set additional_price_currency to 'usd'
    if (!filters.additional_price) {
      filters.additional_price_currency = 'usd'
    }

    let description = ''
    if (get(data, 'jewellery_type') === 'stock_item') {
      description = get(data, 'item_description')
    } else {
      const metalType = formatMetalType(get(data, 'primary_metal_type.metal_type'))
      const diamondShape = startCase(formatDiamondShape(get(data, 'primary_diamond.shape')))
      description = metalType
      if (diamondShape) {
        description += ` · ${diamondShape}`
      }
    }

    let id = getState().cart.nextJewelryId
    dispatch(addJewelryWithId(data, filters, description, id))
    return Promise.resolve()
  }
}

const addJewelryWithId = (data, filters, description, id) => {
  return {
    type: 'ADD_JEWELRY_TO_CART',
    value: { data, filters, description, id }
  }
}

export const setDescriptionEditing = (id, descriptionEditing) => {
  return {
    type: 'JEWELRY_SET_DESCRIPTION_EDITING',
    value: { id, descriptionEditing }
  }
}

export const updateDescription = (id, description) => {
  return {
    type: 'JEWELRY_UPDATE_DESCRIPTION',
    value: { id, description }
  }
}

export const removeJewelryFromCart = (id) => {
  return {
    type: 'REMOVE_JEWELRY_FROM_CART',
    value: id
  }
}

export const editJewelryClicked = (id, data, filters) => {
  return {
    type: 'EDIT_JEWELRY',
    value: { id, data, filters }
  }
}

export const toggleItemCheckout = (type, id) => {
  return {
    type: type === 'diamond' ? 'TOGGLE_DIAMOND_CHECKOUT' : 'TOGGLE_JEWELRY_CHECKOUT',
    value: id
  }
}

export const appraisalCostChanged = (jewelryId, value) => {
  return (dispatch, getState) => {
    const sessionCurrency = getState().settings.currency
    const exchangeRate = getState().settings.exchangeRate
    let appraisalCostInUSD, appraisalCostInCAD

    if (sessionCurrency === 'usd') {
      appraisalCostInUSD = value
      appraisalCostInCAD = parseFloat((value * exchangeRate).toFixed(2))
    } else if (sessionCurrency === 'cad') {
      appraisalCostInUSD = parseFloat((value / exchangeRate).toFixed(2))
      appraisalCostInCAD = value
    }
    dispatch({
      type: 'APPRAISAL_COST_CHANGED',
      value: { jewelryId, appraisalCostInCAD, appraisalCostInUSD }
    })
    return Promise.resolve()
  }
}

export const cartFieldChanged = (field, value) => {
  return {
    type: 'CART_FIELD_CHANGED',
    value: { field, value }
  }
}

export const setDepositRates = () => {
  return dispatch => {
    return api.getDepositRates().then(result => {
      const diamondDepositRate = parseFloat(result.data.filter(item => item.deposit_type === 'diamond')[0].deposit_percentage / 100)
      const jewelryDepositRate = parseFloat(result.data.filter(item => item.deposit_type === 'jewellery')[0].deposit_percentage / 100)
      dispatch({ type: 'SET_DEPOSIT_RATES', value: { diamondDepositRate, jewelryDepositRate } })
    })
  }
}



// WEBPACK FOOTER //
// ./src/actions/cart.js